'use strict';

module.exports = /*@ngInject*/
function(
    $timeout,
    RootCatsHTTPService,
    ConfigHTTPService
) {
    return {
        link: function(scope, element, attrs) {
            ConfigHTTPService.getConfig()
                .then(function onSiteDataRes(config) {
                    RootCatsHTTPService.getRootCats(config.siteId)
                        .then(function onRootCatsRes(res) {
                            scope.rootCatsLookup = res.categories;
                        })
                        .then(function() {
                            $timeout(function() {
                                var i = 0;

                                // TODO: we should be using angular not jQuery to do this
                                for (; i < scope.rootCatsLookup.length; i++) {
                                    if (jQuery('.column-1-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-1-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                    if (jQuery('.column-2-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-2-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                    if (jQuery('.column-3-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-3-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                    if (jQuery('.column-4-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-4-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                    if (jQuery('.column-5-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-5-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                    if (jQuery('.column-6-' + scope.rootCatsLookup[i].categoryId).length > 0) {
                                        jQuery('.column-6-' + scope.rootCatsLookup[i].categoryId).wrapAll('<ul></ul>');
                                    }
                                }
                            }, 1000);
                        });
                });
        }
    };
};
